export default function ensureError<MaybeError>(
  maybeError: MaybeError,
): MaybeError extends Error ? MaybeError : Error {
  if (Error.isError(maybeError)) {
    // @ts-expect-error - conditional return type
    return maybeError;
  }

  // @ts-expect-error - conditional return type
  return new Error(String(maybeError));
}
